// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__Qvwa8","title":"PageHeader_title__M+3oW","subtitle":"PageHeader_subtitle__8fQHf","actions":"PageHeader_actions__Ve3Xc"};